// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"Index_loaderWrapper__eNRAI"};